import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import type { StudentProfile } from "@shared/types/graphqlGenerated";

const StudentProfileCreate_Shared_Mutation = gql`
  mutation StudentProfileCreate_Shared_Mutation($input: StudentProfileCreateInput!) {
    studentProfileCreate(input: $input) {
      studentProfile {
        id
        graduationDate
        createdAt
        updatedAt
      }
      errors {
        message
        fields {
          practitionerTypeId
          graduationDate
        }
      }
    }
  }
`;

interface StudentInformationData {
  practitionerTypeId: string;
  graduationDate: string;
}

interface StudentInformationErrors {
  message?: string;
  fields?: {
    practitionerTypeId?: string[];
    graduationDate?: string[];
  };
}

interface StudentProfileCreateData {
  studentProfileCreate: {
    studentProfile: Pick<StudentProfile, "id" | "graduationDate" | "createdAt" | "updatedAt">;
    errors: StudentInformationErrors;
  };
}

interface Variables {
  input: {
    attributes: StudentInformationData;
  };
}

const useStudentProfileCreateMutation = (
  options?: MutationHookOptions<StudentProfileCreateData, Variables>
) =>
  useMutation<StudentProfileCreateData, Variables>(StudentProfileCreate_Shared_Mutation, options);

export type { StudentProfileCreateData, StudentInformationData, StudentInformationErrors };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useStudentProfileCreateMutation, StudentProfileCreate_Shared_Mutation };
